import { useMutation, useQueryClient } from '@tanstack/react-query'
import { toast } from 'sonner'

import { chatKeys } from '../../keys'
import chatService from '../services'

export function useMutationClaimRoom() {
	const queryClient = useQueryClient()

	return useMutation({
		mutationFn: (roomId: string) => chatService.claimRoom(roomId),
		onSuccess: (data, roomId) => {
			// Update room cache immediately for responsive UI
			queryClient.setQueryData(chatKeys.room(roomId), data)
			// SSE chat:assignee_updated handles rooms() invalidation
			toast.success('รับแชทเรียบร้อยแล้ว')
		},
		onError: () => {
			toast.error('รับแชทไม่สำเร็จ กรุณาลองใหม่อีกครั้ง')
		},
	})
}

export function useMutationReleaseRoom() {
	const queryClient = useQueryClient()

	return useMutation({
		mutationFn: (roomId: string) => chatService.releaseRoom(roomId),
		onSuccess: (data, roomId) => {
			// Update room cache immediately for responsive UI
			queryClient.setQueryData(chatKeys.room(roomId), data)
			// SSE chat:assignee_updated handles rooms() invalidation
			toast.success('ปล่อยแชทเรียบร้อยแล้ว')
		},
		onError: () => {
			toast.error('ปล่อยแชทไม่สำเร็จ กรุณาลองใหม่อีกครั้ง')
		},
	})
}
